import { render, staticRenderFns } from "./ToggleableFormGroup.vue?vue&type=template&id=23164feb&scoped=true&"
import script from "./ToggleableFormGroup.vue?vue&type=script&lang=js&"
export * from "./ToggleableFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./ToggleableFormGroup.vue?vue&type=style&index=0&id=23164feb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23164feb",
  null
  
)

export default component.exports